import { doesRequireLightVersion } from 'utils/deviceDetection';

export const unloadFile = (game, item) => {
  switch (item.type) {
    case 'image':
      if (game.cache.checkImageKey(item.key)) {
        game.cache.removeImage(item.key, true);
      }
      break;
    case 'text':
      if (game.cache.checkTextKey(item.key)) {
        game.cache.removeText(item.key);
      }
      break;
    case 'json':
      if (game.cache.checkJSONKey(item.key)) {
        game.cache.removeJSON(item.key);
      }
      break;
    case 'xml':
      if (game.cache.checkXMLKey(item.key)) {
        game.cache.removeXML(item.key);
      }
      break;
    case 'binary':
      if (game.cache.checkBinaryKey(item.key)) {
        game.cache.removeBinary(item.key);
      }
      break;
    case 'spritesheet':
      if (game.cache.checkKey(item.key)) {
        game.cache.removeSpriteSheet(item.key);
      }
      break;
    case 'video':
      if (game.cache.checkVideoKey(item.key)) {
        game.cache.removeVideo(item.key);
      }
      break;
    case 'tilemap':
      if (game.cache.checkTilemapKey(item.key)) {
        game.cache.removeTilemap(item.key);
      }
      break;
    case 'physics':
      if (game.cache.checkPhysicsKey(item.key)) {
        game.cache.removePhysics(item.key);
      }
      break;
    case 'bitmapFont':
      if (game.cache.checkBitmapFontKey(item.key)) {
        game.cache.removeBitmapFont(item.key);
      }
      break;
    case 'atlasJSONArray':
    case 'atlasJSONHash':
    case 'atlasXML':
    case 'atlas':
    case 'textureatlas':
      game.cache.removeTextureAtlas(item.key);
      break;
    case 'audiosprite':
      game.sounds.removeAudioSprite({ id: item.key });
      break;
    case 'audio':
      game.sounds.removeSound(item.key, item.key);
      break;
    default:
      console.log('asset not unloaded', item.type, item.key);
      break;
  }
};

export const unloadAssetPack = (game, assetpack) => {
  const keys = Object.keys(assetpack);
  keys.forEach((key) => {
    const assets = assetpack[key];
    assets.forEach((item) => {
      unloadFile(game, item);
    });
  });
};

/*
 * returns list of assets to load
 * If lowend, audio path is adjusted from 64 to 32
 */
export const getGameFileLoadList = (game, debug) => {
  if (doesRequireLightVersion()) {
    return game.load._fileList.filter((asset) => {
      /*
       * Adjust audio paths for lowend
       */
      debug && console.log('asset', asset);
      if (asset.type === 'audio') {
        const ary = asset.url.map((pth) => {
          return pth.replace('64', '32');
        });
        asset.url = ary;
        debug && console.log('Adjust audio path', asset.url);
      }
      return asset.type !== 'packfile';
    });
  } else {
    return game.load._fileList.filter((asset) => {
      return asset.type !== 'packfile';
    });
  }
};
